import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faPrint, faHome } from '@fortawesome/free-solid-svg-icons';
import { Copy } from 'react-feather';
import '../../styles/SelamatPage.css';

const SelamatPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const noTiket = params.get('no_tiket');
  const [copySuccess, setCopySuccess] = useState(false);

  // Fungsi untuk mencetak halaman
  const handlePrint = () => {
    window.print(); // Menampilkan dialog print di browser
  };

  // Function to copy ticket number to clipboard (same as SelamatAdminPage)
  const copyToClipboard = () => {
    navigator.clipboard.writeText(noTiket).then(() => {
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 3000);
    });
  };

  return (
    <div className="selamat2-container">
      <div className="selamat2-card">
        <div className="selamat2-header">
          <img src="/logo.png" alt="Logo" className="selamat2-logo" />
          <h2 className="selamat2-title">Kompilasi Informasi Geospasial Tematik</h2>
        </div>
        <div className="selamat2-body">
          <FontAwesomeIcon icon={faCheckCircle} className="selamat2-icon" />
          <p className="selamat2-text">
            Bapak/Ibu Kementerian dan Lembaga, berikut adalah tanda terima Kompilasi Informasi Geospasial Tematik:
          </p>
          <div className="selamat2-ticket">
            <span className="selamat2-ticket-label">Nomor Tiket:</span>
            <div className="ticket-number-container">
              <strong>{noTiket}</strong>
              <button
                className="copy-btn"
                onClick={copyToClipboard}
                title="Salin Nomor Tiket"
              >
                <Copy size={16} />
                {copySuccess ? 'Tersalin!' : 'Salin'}
              </button>
            </div>
          </div>
        </div>
        <div className="selamat2-footer">
          <button className="selamat2-btn selamat2-btn-print" onClick={handlePrint}>
            <FontAwesomeIcon icon={faPrint} /> Cetak
          </button>
          <Link to="/kl" className="selamat2-btn selamat2-btn-home">
            <FontAwesomeIcon icon={faHome} /> Beranda
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SelamatPage;